import axios from '../axios';

class Tracker {
  constructor() {
    this.appKey = 'zhuyiai_website'; // 网站标识
    this.anonymousId = this.getAnonymousId();
    this.userId = this.getUserId();
    this.lastPageViewTime = {}; // 记录每个页面的最后访问时间
    this.pageViewThrottleTime = 3000; // 页面访问埋点节流时间（3秒）
  }

  // 生成事件唯一ID（13位时间戳+5位随机数）
  generateEventId() {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 100000).toString().padStart(5, '0');
    return `${timestamp}${random}`;
  }

  // 获取或生成匿名ID（localStorage存储）
  getAnonymousId() {
    let anonymousId = localStorage.getItem('anonymous_id');
    if (!anonymousId) {
      anonymousId = `anonymous_${Math.random().toString(36).substring(2, 10)}${Date.now().toString(36)}`;
      localStorage.setItem('anonymous_id', anonymousId);
    }
    return anonymousId;
  }

  // 获取登录用户ID
  getUserId() {
    return localStorage.getItem('user_id') || null;
  }

  // 设置登录用户ID
  setUserId(userId) {
    this.userId = userId;
    localStorage.setItem('user_id', userId);
  }

  // 获取设备类型
  getDeviceType() {
    const userAgent = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
      return 'mobile';
    }
    return 'pc';
  }

  // 获取浏览器信息
  getBrowser() {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Chrome') > -1) return 'Chrome';
    if (userAgent.indexOf('Safari') > -1) return 'Safari';
    if (userAgent.indexOf('Firefox') > -1) return 'Firefox';
    if (userAgent.indexOf('Edge') > -1) return 'Edge';
    if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) return 'IE';
    return 'Other';
  }

  // 获取网络类型
  getNetworkType() {
    if (!navigator.connection) return 'unknown';
    const type = navigator.connection.type;
    if (type === 'wifi') return 'wifi';
    if (type === '4g') return '4g';
    if (type === '5g') return '5g';
    return 'unknown';
  }

  // 获取当前时间（UTC+8）
  getCurrentTime() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // 构建基础事件数据
  buildBaseData(eventType, eventName) {
    return {
      event_id: this.generateEventId(),
      user_id: this.userId,
      anonymous_id: this.anonymousId,
      event_type: eventType,
      event_name: eventName,
      event_time: this.getCurrentTime(),
      page_url: window.location.href,
      referrer_url: document.referrer || '',
      device_type: this.getDeviceType(),
      browser: this.getBrowser(),
      network: this.getNetworkType(),
      app_key: this.appKey,
      channel: '', // 推广渠道，可根据实际情况设置
      ext: {}
    };
  }

  // 发送埋点数据
  sendData(data) {
    try {
      // 将ext字段转换为JSON字符串
      const formattedData = {
        ...data,
        ext: JSON.stringify(data.ext)
      };
      
      // 使用新的axios实例，避免与业务请求冲突
      const trackAxios = axios.create({
        timeout: 3000, // 缩短超时时间
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      // 异步发送，不阻塞主线程
      trackAxios.post('/api/behavior/track', formattedData).catch(() => {
        // 静默失败，不通知用户
      });
    } catch (error) {
      // 静默失败，不通知用户
    }
  }

  // 页面访问埋点
  trackPageView(pageName, extraData = {}) {
    const now = Date.now();
    const lastTime = this.lastPageViewTime[pageName] || 0;
    
    // 节流控制：同一页面在指定时间内只发送一次埋点
    if (now - lastTime < this.pageViewThrottleTime) {
      return;
    }
    
    this.lastPageViewTime[pageName] = now;
    const data = this.buildBaseData('page_view', pageName);
    data.ext = { ...data.ext, ...extraData };
    this.sendData(data);
  }

  // 点击事件埋点
  trackClick(targetId, targetText, eventName, extraData = {}) {
    const data = this.buildBaseData('click', eventName);
    data.target_id = targetId;
    data.target_text = targetText;
    data.ext = { ...data.ext, ...extraData };
    this.sendData(data);
  }

  // 错误事件埋点
  trackError(errorMessage, extraData = {}) {
    const data = this.buildBaseData('error', 'api_error');
    data.ext = { ...data.ext, error_message: errorMessage, ...extraData };
    this.sendData(data);
  }
}

export default new Tracker();